import { IconText } from '@delmonicos/shared-design-system-react/src/components/icon-text/icon-text';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Tag } from '@delmonicos/shared-design-system-react/src/components/tag/tag';
import { TokenIsValid } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/token/token-is-valid.enum';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import * as css from './token-is-valid-filter.module.scss';

interface TokenIsValidFilterControllerProps {
  // null (not undefined) represents "All" — react-hook-form's Controller
  // falls back to its mount-time default whenever the live value is
  // undefined, so an explicit clear must never be undefined.
  onChange: (item: boolean | null) => void;
  selectedItem?: boolean | null;
}

export const TokenIsValidFilterController = ({
  onChange,
  selectedItem,
}: TokenIsValidFilterControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // undefined (unset RHF field) and null ("All" sentinel) both mean "no
  // valid filter" — normalize so the "All" tag highlights in both cases.
  const normalizedSelectedItem = selectedItem ?? null;

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const tokenStateList = Object.values(TokenIsValid).map((state) => ({
    key: state,
    label: t(`delmonicos-shared-sdk.outputs-token-is-valid.${state}`),
    value:
      state === TokenIsValid.VALID
        ? true
        : state === TokenIsValid.INVALID
          ? false
          : null,
  }));

  const backgroundColor = (tokenIsValid: TokenIsValid) => {
    switch (tokenIsValid) {
      case TokenIsValid.VALID:
        return 'bg-surface-success';
      case TokenIsValid.INVALID:
        return 'bg-surface-error';
      case TokenIsValid.ALL:
      default:
        return 'bg-surface-brand-secondary';
    }
  };

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Stack direction="column" gap={GapEnum.M}>
      <IconText
        iconName="electric-car-2"
        text={t('delmonicos-shared-sdk.outputs-token.valid')}
      />
      <Stack gap={GapEnum.S} flex={1}>
        {tokenStateList.map((item) => (
          <button
            key={item.key}
            type="button"
            className={css.buttonTag}
            onClick={() => onChange(item.value)}>
            <Tag
              className={classNames(
                backgroundColor(item.key),
                item.value === normalizedSelectedItem && css.selected,
                css.tag,
              )}>
              {item.label}
            </Tag>
          </button>
        ))}
      </Stack>
    </Stack>
  );
};
